<template>
	<div class="select-data-panel">
		<div class="title">您选择了以下内容：</div>
		<div class="select-box" v-if="classifyList.length">
			<div class="classify-title">产品分类</div>
			<div class="tags-box">
				<el-tag
					size="medium"
					v-for="(item, index) in classifyList"
					:key="index"
					closable
					@close="close(index)"
					class="tags"
					>{{ item.title }}</el-tag
				>
			</div>
		</div>
		<div class="select-box" v-if="prdData.length">
			<div class="classify-title">产品</div>
			<div class="tags-box">
				<el-tag
					v-for="(item, index) in prdData"
					:key="index"
					class="tags"
					size="medium"
					@close="close_prd(index)"
					closable
					>{{ item.title }}</el-tag
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		classifyList: {
			type: Array,
		},
		prdData: {
			type: Array,
		},
	},
	data() {
		return {};
	},

	components: {},

	computed: {},

	methods: {
		close(index) {
			this.$emit('handleClose', index);
		},
		close_prd(index) {
			this.$emit('close_prd', index);
		},
	},
};
</script>

<style lang="scss" scoped>
.select-data-panel {
	background: #ffffff;

	margin: 10px 0px;
	padding: 30px;
	.title {
		font-size: 16px;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.85);
	}
	.classify-title {
		width: 65px;
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		margin-right: 30px;
		text-align: right;
	}
	.select-box {
		display: flex;
		align-items: baseline;
		padding-left: 100px;
		padding-top: 25px;
	}
	.tags-box {
		flex: 1;
	}
	.tags {
		margin-right: 10px;
		margin-bottom: 10px;
	}
}
</style>
